import { serviceAreas } from "@/mocks/services";
import { Link } from "react-router-dom";

interface ServiceAreasProps {
  showMap?: boolean;
}

export default function ServiceAreas({ showMap = true }: ServiceAreasProps) {
  return (
    <section className="bg-[#071220] py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          {/* Left */}
          <div>
            <p className="font-['Inter'] text-[#7DD3FC] text-xs font-semibold uppercase tracking-[0.18em] mb-4">
              Coverage Area
            </p>
            <h2 className="font-['Playfair_Display'] text-white text-4xl md:text-5xl font-bold leading-tight mb-6">
              Serving McKinney, Dallas &amp; the DFW Metro
            </h2>
            <p className="font-['Inter'] text-white text-base leading-[1.85] mb-8">
              Based in McKinney, TX, Knight In Shining Armor Heating &amp; Air provides professional HVAC services across the entire Dallas metro area — including surrounding communities that count on fast, reliable cooling and heating service.
            </p>

            {/* Area Tags */}
            <div className="flex flex-wrap gap-2.5 mb-8">
              {serviceAreas.map((area) => (
                <Link
                  key={area.id}
                  to={area.href}
                  className="flex items-center gap-2 border border-white/20 hover:border-[#0EA5E9]/50 hover:bg-[#0EA5E9]/8 text-white hover:text-white font-['Inter'] text-sm px-4 py-2 rounded-full transition-all duration-300 whitespace-nowrap"
                >
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-map-pin-2-line text-[#7DD3FC] text-xs"></i>
                  </div>
                  {area.name}
                </Link>
              ))}
            </div>

            {/* Contact Block */}
            <div className="bg-[#050F1A] border border-white/6 rounded-2xl p-6">
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#0EA5E9]/10 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#7DD3FC] text-lg"></i>
                </div>
                <div>
                  <div className="font-['Inter'] text-white font-semibold text-sm mb-0.5">Our Location</div>
                  <address className="font-['Inter'] text-white text-sm not-italic">
                    833 Inwood Dr, McKinney, TX 75069
                  </address>
                </div>
              </div>
              <a
                href="tel:2148703185"
                className="inline-flex items-center gap-2 bg-[#0EA5E9] hover:bg-[#0284C7] text-white font-['Inter'] font-semibold text-sm px-5 py-2.5 rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-fill text-white text-xs"></i>
                </div>
                Call 214-870-3185
              </a>
            </div>
          </div>

          {/* Right — Map */}
          {showMap && (
            <div className="relative rounded-2xl overflow-hidden border border-white/6 h-[420px]">
              <iframe
                title="Knight In Shining Armor KISA Cooling McKinney Dallas Service Area"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d107288.18617767!2d-96.7388!3d33.1972!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864c2220e9b4aa31%3A0x7d8b9f6ab1c0b4d0!2sMcKinney%2C%20TX!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                className="absolute inset-0 w-full h-full"
                style={{ border: 0, filter: "invert(90%) hue-rotate(180deg) brightness(0.85) contrast(0.9)" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
